var okeResponse = (success, code, message, data) => {
  return {
    success,
    code,
    message,
    data
  }
}
  
module.exports = okeResponse